import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

export const formatHistoryDate = isoString => {
  if (!isoString) {
    return '';
  }

  return dayjs(isoString).format(COMMON_DATETIME_FORMAT);
};

export const getActorLabel = ({ actorType, changedByUserId, userName }) => {
  if (actorType === 'System') {
    return 'System';
  }

  return userName ?? changedByUserId ?? 'Unknown';
};
